export default __webpack_public_path__ + "static/media/chevron-down.91b060b4.svg";